<template>
  <div style="height:100%">
    <div class="left-list leftList">
      <template v-for="(data,index) in dataList">
        <!-- <div></div> -->
        <div class="left-list" :key="index">
          <template v-for="(value,key) in data">
            <div class="left-row" :key="key">
              <span class="sp1">{{key}}</span>
              <span class="sp2">{{value.replace('null'||'undefined','0')}}</span>
            </div>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data", "keyMap"],
  data() {
    return {};
  },
  watch: {
    data: function (newV) {
      console.log(newV,"leftdata")
    },
  },
  computed: {
    dataList() {
      const dataList = this.data instanceof Array ? this.data : [this.data];
      // console.log(dataList)
      // console.log('data',this.data)
      // console.log('keyMap',this.keyMap)
      return dataList.map((item) => {
        const obj = {};
        for (let key in this.keyMap) {
          // console.log(item[key])
          // console.log(key)
          if (item[key] || item[key] == 0 ||item[key]==null) {
            obj[this.keyMap[key][0]] = item[key] + (this.keyMap[key][1] || "");
          }
        }
        console.log(obj,'obj')
        return obj;
      });
    },
  },
  filter: {},
  created() {},
  mounted() {},
  methods: {},
  components: {},
};
</script>

<style lang="scss" scoped="">
.leftList{
  height: 100%;
  width: 100% !important;
  overflow: auto; 
  // padding: 20px 0
}
.left-list {
  // padding: 20px 10px;
  // margin-bottom: 20px;
  width: 100%;
  margin-top: 16px;
  .left-row {
    // padding: 10px 20px;
    // line-height: 24px;
    height: 40px;
    border: 1px solid #e1e1e1;
    &:nth-child(n + 2) {
      border-top: none;
    }
    .sp1 {
      display: inline-block;
      width: 50%;
      height: 100%;
      line-height: 40px;
      background: rgba(0, 0, 0, 0.03);
      font-size: 16px;
      padding-left: 16px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.5);;
    }
    .sp2 {
      display: inline-block;
      width: 50%;
      height: 100%;
      line-height: 40px;
      // background: rgba(0, 0, 0, 0.03);
      font-size: 14px;
      padding-left: 16px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.8);;
    }
  }
}
</style>